// Lot 684 — forme d'onde + durée d'un audio servies par le serveur (GET /api/media/peaks, calculées une fois par ffmpeg
// et mises en cache). Plus AUCUN décodage audio sur le téléphone : avant, chaque lecteur téléchargeait tout le fichier
// et le décodait en PCM brut (decodeAudioData) — un enseignement de 67 min ≈ 1,4 Go décompressés → iOS tuait le
// processus WebKit et la page rechargeait (retour en haut du fil). Seuls les fichiers LOCAUX (blob:/data: — aperçu
// d'un enregistrement avant envoi, quelques secondes) restent décodés sur l'appareil par l'appelant.
import { api } from "@/lib/api";

const cache = new Map(); // `${bars}|${url}` → Promise<{ peaks: number[], duration: number }>

export const isLocalMediaUrl = (u) => typeof u === "string" && (u.startsWith("blob:") || u.startsWith("data:"));

// `rawUrl` : l'URL telle que connue du client (/api/files/…, URL CDN absolue, URL proxy) — le serveur en déduit le fichier.
export const fetchAudioPeaks = (rawUrl, bars = 40) => {
  if (!rawUrl || isLocalMediaUrl(rawUrl)) return Promise.reject(new Error("local-media"));
  const key = `${bars}|${rawUrl}`;
  if (!cache.has(key)) {
    const p = api.get("/media/peaks", { params: { u: rawUrl, bars }, timeout: 60000 }).then(({ data }) => {
      const peaks = Array.isArray(data?.peaks) ? data.peaks.map(Number).filter((v) => Number.isFinite(v)) : [];
      if (!peaks.length) throw new Error("no-peaks");
      return { peaks, duration: Number.isFinite(Number(data?.duration)) ? Number(data.duration) : 0 };
    });
    p.catch(() => cache.delete(key)); // un échec (réseau, 404) n'est pas mémorisé : le prochain lecteur réessaie
    cache.set(key, p);
  }
  return cache.get(key);
};

export const _resetAudioPeaksForTests = () => cache.clear();
